import React from 'react';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import Section from '../components/Section';
import { Sparkles, X, Image as ImageIcon } from 'lucide-react';
import './Ministries.css';

const MinistryCard = ({ title, leaders, description, image, onClick }) => (
    <div className="ministry-card hover-lift animate-fade-in-up" onClick={onClick}>
        <div className="ministry-card-image" style={{ backgroundImage: `url("${image}")` }}>
            <div className="gallery-overlay">
                <ImageIcon size={24} />
                <span>View Gallery</span>
            </div>
        </div>
        <div className="ministry-card-content">
            <h3>{title}</h3>
            {leaders && <p className="leader-name">Leader: {leaders}</p>}
            <p className="ministry-desc">{description}</p>
        </div>
    </div>
);

const GalleryModal = ({ ministry, onClose }) => {
    if (!ministry) return null;

    return (
        <div className="gallery-modal-overlay" onClick={onClose}>
            <div className="gallery-modal-content" onClick={e => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}><X size={32} /></button>
                <div className="modal-header">
                    <h2>{ministry.title} Gallery</h2>
                    <p>Leader: {ministry.leaders}</p>
                </div>
                <div className="gallery-grid">
                    {ministry.gallery.map((img, index) => (
                        <div key={index} className="gallery-item">
                            <img src={img} alt={`${ministry.title} ${index + 1}`} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

const Ministries = () => {
    const [selectedMinistry, setSelectedMinistry] = React.useState(null);
    const [selectedActivity, setSelectedActivity] = React.useState(null);

    const ministries = [
        {
            title: "Men's Ministry",
            leaders: "Deacon Roki",
            image: "/Images/Mens/WhatsApp Image 2026-06-15 at 2.02.08 PM (1).jpeg",
            description: "Building strong men of God through fellowship, activities (braaing, soccer), and deep study of the Word.",
            gallery: ["/Images/Mens/WhatsApp Image 2026-06-15 at 2.02.08 PM (1).jpeg", "/Images/Mens/WhatsApp Image 2026-06-15 at 2.02.08 PM.jpeg"]
        },
        {
            title: "Ladies' Ministry",
            leaders: "Mrs Mbuva",
            image: "/Images/Ladies/WhatsApp Image 2026-06-15 at 2.02.03 PM (1).jpeg",
            description: "Empowering women to walk in their God-given purpose through discussion and prayer.",
            gallery: ["/Images/Ladies/WhatsApp Image 2026-06-15 at 2.02.03 PM (1).jpeg", "/Images/Ladies/WhatsApp Image 2026-06-15 at 2.02.03 PM (2).jpeg", "/Images/Ladies/WhatsApp Image 2026-06-15 at 2.02.03 PM (3).jpeg", "/Images/Ladies/WhatsApp Image 2026-06-15 at 2.02.03 PM.jpeg"]
        },
        {
            title: "Youth Ministries",
            leaders: "Pastor Maseko",
            image: "/Images/Youth Ministry/WhatsApp Image 2026-06-15 at 2.02.02 PM (1).jpeg",
            description: "Dynamic and high-energy ministry for teenagers and students to connect through games and faith.",
            gallery: [
                "/Images/Youth Ministry/WhatsApp Image 2026-06-15 at 2.02.01 PM (3).jpeg",
                "/Images/Youth Ministry/WhatsApp Image 2026-06-15 at 2.02.02 PM (1).jpeg",
                "/Images/Youth Ministry/WhatsApp Image 2026-06-15 at 2.02.02 PM (2).jpeg",
                "/Images/Youth Ministry/WhatsApp Image 2026-06-15 at 2.02.02 PM.jpeg"
            ]
        },
        {
            title: "Children's Ministry",
            leaders: "Reverend Ngoreta",
            image: "https://images.unsplash.com/photo-1494883110141-94572227282a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
            description: "Nurturing the next generation in a fun, safe, and Spirit-led environment.",
            gallery: []
        },
        {
            title: "Couples Ministry",
            leaders: "Deacon Rutsito & Pastor Rutsito (Mrs)",
            image: "/Images/Couples/WhatsApp Image 2026-06-15 at 2.01.59 PM (1).jpeg",
            description: "Strengthening marriages effectively through biblical principles and fellowship.",
            gallery: [
                "/Images/Couples/WhatsApp Image 2026-06-15 at 2.01.59 PM (1).jpeg",
                "/Images/Couples/WhatsApp Image 2026-06-15 at 2.01.59 PM (2).jpeg",
                "/Images/Couples/WhatsApp Image 2026-06-15 at 2.01.59 PM (3).jpeg",
                "/Images/Couples/WhatsApp Image 2026-06-15 at 2.01.59 PM (4).jpeg",
                "/Images/Couples/WhatsApp Image 2026-06-15 at 2.01.59 PM.jpeg",
                "/Images/Couples/WhatsApp Image 2026-06-15 at 2.02.00 PM (1).jpeg",
                "/Images/Couples/WhatsApp Image 2026-06-15 at 2.02.00 PM (2).jpeg",
                "/Images/Couples/WhatsApp Image 2026-06-15 at 2.02.00 PM.jpeg"
            ]
        },
        {
            title: "Young Adults Ministry",
            leaders: "Pastor S Rutsito",
            image: "/Images/Young Adults Ministry/young adults.jpg",
            description: "A vibrant community for professionals and students to grow together.",
            gallery: ["/Images/Young Adults Ministry/young adults.jpg"]
        }
    ];

    const activities = [
        {
            title: "Church Services",
            category: "Worship & Word",
            image: "/Images/Church Service/congregation.jpg",
            description: "Powerful and engaging church services full of the Holy Spirit, worship, and impactful sermons.",
            gallery: [
                "/Images/Church Service/congregation.jpg",
                "/Images/Church Service/WhatsApp Image 2026-01-31 at 2.14.09 PM (1).jpeg",
                "/Images/Church Service/WhatsApp Image 2026-01-31 at 2.14.10 PM (1).jpeg",
                "/Images/Church Service/WhatsApp Image 2026-01-31 at 2.14.11 PM (2).jpeg",
                "/Images/Church Service/WhatsApp Image 2026-01-31 at 2.14.12 PM (1).jpeg",
                "/Images/Church Service/worship.jpeg"
            ]
        },
        {
            title: "Family Fun Day",
            category: "Community",
            image: "/Images/Family Fun Day/WhatsApp Image 2026-06-15 at 2.01.58 PM.jpeg",
            description: "A joyous occasion where church families gather for fun, games, and fellowship in a relaxed setting.",
            gallery: [
                "/Images/Family Fun Day/WhatsApp Image 2026-06-15 at 2.01.44 PM.jpeg",
                "/Images/Family Fun Day/WhatsApp Image 2026-06-15 at 2.01.47 PM.jpeg",
                "/Images/Family Fun Day/WhatsApp Image 2026-06-15 at 2.01.56 PM.jpeg",
                "/Images/Family Fun Day/WhatsApp Image 2026-06-15 at 2.01.57 PM (1).jpeg",
                "/Images/Family Fun Day/WhatsApp Image 2026-06-15 at 2.01.57 PM (2).jpeg",
                "/Images/Family Fun Day/WhatsApp Image 2026-06-15 at 2.01.57 PM.jpeg",
                "/Images/Family Fun Day/WhatsApp Image 2026-06-15 at 2.01.58 PM (1).jpeg",
                "/Images/Family Fun Day/WhatsApp Image 2026-06-15 at 2.01.58 PM.jpeg",
                "/Images/Family Fun Day/WhatsApp Image 2026-06-15 at 2.02.02 PM (3).jpeg",
                "/Images/Family Fun Day/WhatsApp Image 2026-06-15 at 2.02.04 PM.jpeg",
                "/Images/Family Fun Day/WhatsApp Image 2026-06-15 at 2.02.06 PM (1).jpeg",
                "/Images/Family Fun Day/WhatsApp Image 2026-06-15 at 2.02.06 PM (2).jpeg",
                "/Images/Family Fun Day/WhatsApp Image 2026-06-15 at 2.02.06 PM (3).jpeg",
                "/Images/Family Fun Day/WhatsApp Image 2026-06-15 at 2.02.06 PM.jpeg",
                "/Images/Family Fun Day/WhatsApp Image 2026-06-15 at 2.02.07 PM (1).jpeg",
                "/Images/Family Fun Day/WhatsApp Image 2026-06-15 at 2.02.07 PM (2).jpeg",
                "/Images/Family Fun Day/WhatsApp Image 2026-06-15 at 2.02.07 PM (3).jpeg",
                "/Images/Family Fun Day/WhatsApp Image 2026-06-15 at 2.02.07 PM.jpeg"
            ]
        },
        {
            title: "Baptism",
            category: "Life Milestone",
            image: "/Images/Baptism/baptism.jpeg",
            description: "Publicly declaring our faith through water baptism. A beautiful moment of celebration.",
            gallery: [
                "/Images/Baptism/baptism.jpeg",
                "/Images/Baptism/WhatsApp Image 2026-01-31 at 2.14.11 PM.jpeg"
            ]
        },
        {
            title: "Evangelism",
            category: "Outreach",
            image: "/Images/Evangelism/evangelism.jpeg",
            description: "Taking the hope of Christ to our community through active outreach and love.",
            gallery: [
                "/Images/Evangelism/evangelism.jpeg",
                "/Images/Evangelism/Rev R Chimbetete and Pastor C Chimbetet.jpg",
                "/Images/Evangelism/WhatsApp Image 2026-01-31 at 2.14.10 PM (2).jpeg",
                "/Images/Evangelism/WhatsApp Image 2026-06-15 at 2.01.35 PM.jpeg",
                "/Images/Evangelism/WhatsApp Image 2026-06-15 at 2.01.39 PM.jpeg",
                "/Images/Evangelism/WhatsApp Image 2026-06-15 at 2.01.41 PM.jpeg",
                "/Images/Evangelism/WhatsApp Image 2026-06-15 at 2.02.01 PM (1).jpeg",
                "/Images/Evangelism/WhatsApp Image 2026-06-15 at 2.02.01 PM (2).jpeg",
                "/Images/Evangelism/WhatsApp Image 2026-06-15 at 2.02.01 PM.jpeg"
            ]
        },
        {
            title: "Graduation",
            category: "Celebration",
            image: "/Images/Graduation/graduation.jpeg",
            description: "Celebrating the achievements and growth of our church family members.",
            gallery: [
                "/Images/Graduation/graduation.jpeg",
                "/Images/Graduation/grad.jpg",
                "/Images/Graduation/183637617_3437562466343218_3935898257686154900_n.jpg",
                "/Images/Graduation/WhatsApp Image 2026-01-31 at 2.14.10 PM.jpeg",
                "/Images/Graduation/WhatsApp Image 2026-06-15 at 2.02.05 PM (1).jpeg",
                "/Images/Graduation/WhatsApp Image 2026-06-15 at 2.02.05 PM (2).jpeg"
            ]
        },
        {
            title: "Baby Dedication",
            category: "Life Milestone",
            image: "/Images/Baby Dedication/WhatsApp Image 2026-06-15 at 2.02.04 PM (1).jpeg",
            description: "Dedicating our little ones to the Lord, celebrating new life and committing to raise them in faith.",
            gallery: [
                "/Images/Baby Dedication/WhatsApp Image 2026-06-15 at 2.02.04 PM (1).jpeg",
                "/Images/Baby Dedication/WhatsApp Image 2026-06-15 at 2.02.04 PM (2).jpeg",
                "/Images/Baby Dedication/WhatsApp Image 2026-06-15 at 2.02.04 PM (3).jpeg",
                "/Images/Baby Dedication/WhatsApp Image 2026-06-15 at 2.02.05 PM.jpeg"
            ]
        }
    ];

    return (
        <Layout>
            <SEO title="Ministries" description="Discover the various ministries at PAOZ Hope Community Church and get involved." />
            <div className="page-hero" style={{ backgroundImage: 'url("/Images/minstries.jpg")' }}>
                <div className="container">
                    <h1 className="animate-fade-in-up">Our Ministries</h1>
                    <p className="animate-fade-in-up delay-100">Experience Life at PAOZ HCC</p>
                </div>
            </div>

            <Section>
                <div className="ministry-intro text-center animate-fade-in-up">
                    <div className="icon-badge"><Sparkles size={24} /></div>
                    <h2 className="premium-title">Core Ministries</h2>
                    <p className="max-600">Our ministries exist to serve every stage of life, providing a place to grow and belong.</p>
                </div>

                <div className="ministry-grid-premium">
                    {ministries.map((item, index) => (
                        <MinistryCard key={index} {...item} onClick={() => setSelectedMinistry(item)} />
                    ))}
                </div>

                <GalleryModal
                    ministry={selectedMinistry}
                    onClose={() => setSelectedMinistry(null)}
                />
            </Section>

            <Section className="bg-dark text-white gallery-section">
                <div className="text-center mb-60 animate-fade-in-up">
                    <h2 className="premium-title color-white">What We Do</h2>
                    <p className="max-600 color-white opacity-8">Showcasing the journey of faith and community at HCC.</p>
                </div>

                <div className="activity-masonry">
                    {activities.map((item, index) => (
                        <div key={index} className="activity-item hover-lift animate-fade-in-up" onClick={() => setSelectedActivity(item)}>
                            <img src={item.image} alt={item.title} />
                            <div className="activity-overlay">
                                <h3>{item.title}</h3>
                                <p>{item.description}</p>
                                <span className="item-category">{item.category}</span>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Activity Lightbox */}
                {selectedActivity && (
                    <div className="gallery-modal-overlay" onClick={() => setSelectedActivity(null)}>
                        <div className="gallery-modal-content" onClick={e => e.stopPropagation()}>
                            <button className="modal-close" onClick={() => setSelectedActivity(null)}><X size={32} /></button>
                            <div className="modal-header">
                                <h2>{selectedActivity.title} Gallery</h2>
                                <p>{selectedActivity.category}</p>
                            </div>
                            <div className="lightbox-desc" style={{ marginBottom: '20px' }}>
                                <p>{selectedActivity.description}</p>
                            </div>
                            <div className="gallery-grid">
                                {(selectedActivity.gallery || [selectedActivity.image]).map((img, index) => (
                                    <div key={index} className="gallery-item">
                                        <img src={img} alt={`${selectedActivity.title} ${index + 1}`} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </Section>
        </Layout>
    );
};

export default Ministries;
